 
import axios from "../../../config/AxiosConfig";
import { put } from "redux-saga/effects";
import {
  CREATE_SUPPORT_REQUEST_API,
  GET_SUPPORT_REQUESTS_API,
} from "../../actions/apiCollections";
import * as actions from "../../actions/support/supportActions";

export function* createSupportRequestSaga(action) {
  yield put(actions.supportRequestLoading());
  try {
    const response = yield axios.post(
      `${CREATE_SUPPORT_REQUEST_API}?lng=en`,
      action.supportData
    );
    yield put(actions.createSupportRequestSuccess(response.data?.data));
  } catch (error) {
    yield put(actions.createSupportRequestFail(error?.response?.data?.message));
  }
}

export function* getSupportRequestsSaga(action) {
  try {
    yield put(actions.supportRequestStart(action.pageLimit));
    const response = yield axios.get(`${GET_SUPPORT_REQUESTS_API}?lng=en`, {
      params: {
        limit: 10 * action.pageLimit,
      },
    });
    yield put(actions.getSupportRequestsSuccess(response.data?.data));
  } catch (error) {
    yield put(actions.getSupportRequestsFail(error?.response?.data?.message));
  }
}
